import React, { Component } from 'react';
import PropTypes from 'prop-types';
import constants from '@constants';
import isEqual from 'lodash/isEqual';

class CheckBox extends Component {
	shouldComponentUpdate = ({ value, statusId }) => {
		const lastProps = this.props;

		return (
			isEqual(value, lastProps.value)
			|| isEqual(statusId, lastProps.statusId)
		);
	}

	render() {
		const {
			value, rowIndex, statusId, onCheckBoxChange, name,
		} = this.props;

		return (
			<If condition={statusId !== constants.INVOICE_STATUSES.PENDING_PROCESSING}>
				<div className="checkbox-clickable-outline">
					<button className="btn btn-link" type="button" aria-label={name} data-clickable onClick={onCheckBoxChange(rowIndex, !value)} />
					<label className="big-checkbox">
						<input
							type="checkbox"
							data-clickable
							name={name}
							checked={value}
							onChange={onCheckBoxChange(rowIndex, !value)}
						/>
						<span data-clickable className="clickable checkmark" />
					</label>
				</div>
			</If>
		);
	}
}

CheckBox.propTypes = {
	name             : PropTypes.string,
	onCheckBoxChange : PropTypes.func.isRequired,
	rowIndex         : PropTypes.number.isRequired,
	statusId         : PropTypes.number,
	value            : PropTypes.bool,
};

CheckBox.defaultProps = {
	name     : '',
	value    : false,
	statusId : -1,
};

export default CheckBox;
